import React, { Component } from 'react';
import PropTypes from 'prop-types';
var QRCode = require('qrcode-react');
import Style from './index.less';
import './index.less';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import Checkbox from '@tencent/dui/lib/components/Checkbox';


export default class LiveInviteDialog extends Component {

    static propTypes = {
        darkMode: PropTypes.bool,
    };

    static defaultProps = {
        darkMode: true,
    };

    constructor(props) {
        super(props);
        this.liveManager = this.props.liveDelegate;
        this.url = this.liveManager.shareUrl;
        this.state = {
            allowFlip: this.liveManager.allowFlip() || false,
            visible: false,
            toastText: '',
            type:'success',
        }
        this.snackTimer = 0;

    }

    copyLink = () => {
        this.props.onCopyLink && this.props.onCopyLink(this.url);
    }

    handleSnackbarClose = () => {
        this.setState({ visible: false });
    };

    showSnackbar = (param) => {
        this.setState({
            visible: true,
            toastText: param.message,
            type: param.type,
        });
        if (this.snackTimer !== null) {
            clearTimeout(this.snackTimer);
        }
        this.snackTimer = setTimeout(this.handleSnackbarClose, param.duration);
    }

    checkboxHandler() {
        // do nothing.
    }
    
    onClickClose = () => {
        this.onClose('close');
    }

    onClickPlay = () => {
        this.onClose('play');
    }

    onClickEndShow = () =>  {
        this.onClose('end show');
    }

    onClose = (action) => {
        let state = {
            action: action,
        }
        this.props.handleCloseDialog && this.props.handleCloseDialog(state);
    }

    clickQRCode = () => { }

    onCheckChanged = value => {
        this.setState({ allowFlip: value });
        this.props.onFlipChanged && this.props.onFlipChanged(value);
    }
    
    render() {
        let url = this.url;
        let xsrf = '906147608296426f';
        const hostname = (window.location && window.location.hostname) || 'docs.qq.com';
        let qrcode = `https://${hostname}/cgi-bin/online_docs/qrcode?xsrf=${xsrf}&url=${encodeURIComponent(url)}&t=${Date.now()}`;
        let checkStye = {
            fontSize:'16px',
        }
        let bubbleDark = (this.props.darkMode ? (' bubble-dark-invite ' + Style['bubble-dark-invite']) : (' bubble-invite ' + Style['bubble-invite']) );
        const { visible, type, toastText } = this.state;

        return (

            <Snackbar.Container className={'dialog-wrapper-invite ' + Style['dialog-wrapper-invite'] + ' bubble-invite ' + Style['bubble-invite'] + ' top-invite ' + Style['top-invite'] + bubbleDark}>
                <Snackbar closable
                    onClose={this.handleSnackbarClose}
                    type={type}
                    visible={visible}
                >
                    {toastText}
                </Snackbar>
                {this.props.showArrow &&
                    <div className={this.props.darkMode ? ('top-tip-dark-invite ' + Style['top-tip-dark-invite']) : ('top-tip-invite ' + Style['top-tip-invite'])} />
                }
                <button aria-label="Close" className={'modal-close-invite ' + Style['modal-close-invite']} onClick={this.onClickClose}>
                    <span className={'modal-close-x-invite ' + Style['modal-close-x-invite']}></span>
                </button>
                <div className={'modal-content-invite ' + Style['modal-content-invite']}>
                    <h1 className={this.props.darkMode ? ('dark-text-invite ' + Style['dark-text-invite']) : null}>邀请好友加入</h1>
                    <div className={'sm-qrcode-invite ' + Style['sm-qrcode-invite']}
                        onClick={this.clickQRCode}
                    >
                        <QRCode value={this.url} ref={r => { this.qrCode = r; }}
                            size={120}
                        ></QRCode>
                    </div>
                    {this.props.darkMode ?
                        <div className={'link-wrapper-dark-invite ' + Style['link-wrapper-dark-invite']}>
                            <div className={'input-wrapper-dark-invite ' + Style['input-wrapper-dark-invite']}>
                                <input id="bar" ref={e => { this.inputBar = e }}
                                    className={'input-link-dark-invite ' + Style['input-link-dark-invite']} type="text" value={url} onChange={e=>{}}
                                />
                            </div>
                            <button className={'copy-text-dark-invite ' + Style['copy-text-dark-invite']} data-clipboard-target="#bar" onClick={this.copyLink}>复制链接</button>
                        </div>
                        :
                        <div className={'link-wrapper-invite ' + Style['link-wrapper-invite']}>
                            <div className={'input-wrapper-invite ' + Style['input-wrapper-invite']}>
                                <input id="bar" ref={e => { this.inputBar = e }}
                                    className={'input-link-invite ' + Style['input-link-invite']} type="text" value={url} onChange={e=>{}}
                                />
                            </div>
                            <button className={'copy-text-invite ' + Style['copy-text-invite']} data-clipboard-target="#bar" onClick={this.copyLink}>复制链接</button>
                        </div>
                    }

                    <div>
                        {this.props.hidePlay ? null :
                            <button className={'blue-button-invite ' + Style['blue-button-invite']} type="default" onClick={this.onClickPlay}>开始远程演示</button>
                        }
                        {this.props.hideClose ? null :
                            <button className={'white-button-invite ' + Style['white-button-invite']} type="black" onClick={this.onClickEndShow}>关闭邀请</button>
                        }
                        {this.props.hideAllowFlip ? null :
                            <div className={'div-check-invite ' + Style['div-check-invite']}>
                                <Checkbox
                                    checked={this.state.allowFlip}
                                    onChange={this.onCheckChanged} 
                                    style={checkStye}
                                >
                                    允许观看者翻看文档全文
                                </Checkbox>
                            </div>
                        }
                    </div>
                </div>
            </Snackbar.Container>
        );
    }
}
